import axios from 'axios'

// Výchozí nastavení
//const ServiceBaseURL = 'https://eagri.cz/ssl/app/uhul/mtest/ws.KN/ServiceKNj.svc';
var ServiceBaseURL = '';
var ServiceWithCredentials = true;
var ServiceHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};
var ServiceResponseType = 'text';

var apiClient

/* const apiClient = axios.create({
    baseURL: ServiceBaseURL,
    withCredentials: true, // This is the default
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
    responseType: 'text',
}) */

export default {

    // Inicializace
    Init(url) {
        ServiceBaseURL = url;
        apiClient = axios.create({
            baseURL: ServiceBaseURL,
            withCredentials: ServiceWithCredentials,
            headers: ServiceHeaders,
            responseType: ServiceResponseType,
        })
    },


    // číselníky
    KnSeznam(JmenoCis) {
        return apiClient.get(`/` + JmenoCis, {})
    },


    // Výpis PAR
    KnGenerujInfoOParcelach(katastrUzemiKod, kmenoveCislo, poddeleni) {
        return apiClient.get(`/KnGenerujInfoOParcelach`, {
            params: {
                katastrUzemiKod: katastrUzemiKod,
                kmenoveCislo: kmenoveCislo,
                poddeleni: poddeleni,
            }

        })
    },


}

